import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {QueryStringService} from '@/services/QueryStringService/QueryStringService';

type MbHeadersData = {
  mbversion: string;
  platform: string;
  auth: string;
};

// Сервис необходим для детального понимания запросов, откуда они были сделаны, в какую сессию пользователя
// Так же в сервис отвечает за установку x-project-auth-token, фоллбэк на случай если авторизационная кука в МБ слетела
export class ProjectApiHeaders {
  private headersData = {
    authToken: '',
    sessionId: '',
    userId: '',
    mb: {
      mbversion: '',
      platform: '',
      auth: '',
    },
  };

  constructor(private readonly queryStringService: QueryStringService) {}

  public setAuthToken = (authToken: string): void => {
    this.headersData.authToken = authToken;
  };

  public setMbHeadersData = (): void => {
    const data = {
      mbversion: this.queryStringService.getMobileVersion() || '',
      platform: this.queryStringService.getPlatform() || '',
      auth: this.queryStringService.getAuth() || '',
    };

    Object.entries(data).map(([key, value]) => {
      this.headersData.mb[key as keyof MbHeadersData] = value;
    });
  };

  public setUserIdData = (id: string): void => {
    this.headersData.userId = id;
  };

  public setSessionIdData = (sessionId: string): void => {
    this.headersData.sessionId = sessionId;
  };

  public getHeaders = (): Record<string, string> => {
    const mbHeaders: Record<string, string> = {};

    Object.entries(this.getMbHeadersData()).forEach(([key, value]) => {
      mbHeaders[`x-project-${key}`] = value;
    });

    return {
      ...mbHeaders,
      'x-project-session-id': this.getSessionIdData(),
      'x-project-user-id': this.getUserIdData(),
      'x-project-auth-token': this.getAuthToken(),
    };
  };

  private getSessionIdData = (): string => {
    return this.headersData.sessionId;
  };

  private getMbHeadersData = (): MbHeadersData => {
    return this.headersData.mb;
  };

  private getUserIdData = (): string => {
    return this.headersData.userId;
  };

  private getAuthToken = (): string => {
    return this.headersData.authToken;
  };
}

injected(ProjectApiHeaders, DI_TOKENS.queryStringService);
